import type {Appearance, CssFontSource} from '@stripe/stripe-js';

import colors from 'app/styles/colors.json';

// Stripe's form renders in its own iframe, which neither inherits the page's font nor can load the
// Lato bundled into the app, so it fetches its own copy.
export const STRIPE_FONTS: CssFontSource[] = [
  {cssSrc: 'https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap'},
];

// Gets Stripe's form close to Blueprint's inputs. The seam is deliberate — matching exactly would
// mean rebuilding the card form ourselves, and Stripe's is the one that stays PCI-scoped.
export const STRIPE_APPEARANCE: Appearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: colors.primaryIntent,
    colorDanger: colors.red,
    fontFamily: "'Lato', Helvetica, Arial, sans-serif",
    borderRadius: '3px',
    spacingUnit: '4px',
  },
};
